import { getValue, getCheckboxChecked } from './validate';
import { alertCtk, alertCtkApiError } from './utils';
import {
  ajaxUniPostUsingCaptcha,
  ajaxPlatebniBranaPost,
  checkOkStatusInSuccessFunc,
} from './ajaxutils';

const jQuery = window.jQuery;
const cnfg_http_mojectk_php_base = window.cnfg_http_mojectk_php_base;

export function ajaxSubmit() {
  const data = {};
  data.lengthcode = jQuery('input[name=length]:checked').val();
  data.company = getValue('company');
  data.name = getValue('name');
  data.surname = getValue('surname');
  data.email = getValue('email');
  data.phone = getValue('phone');
  data.street = getValue('street');
  data.city = getValue('city');
  data.psc = getValue('psc');
  data.country = getValue('country');
  data.ic = getValue('ic');
  data.dic = getValue('dic');
  data.register = getCheckboxChecked('register') ? 'on' : 'off';
  data.passwd = getValue('passwd');

  const jsondata = JSON.stringify(data);
  console.log('jsondata: ' + jsondata);

  const successFunc = (result, textStatus, jqXHR) => {
    console.log('save MakeGuestOrder returned');
    if (!checkOkStatusInSuccessFunc(result, textStatus, jqXHR)) {
      return false;
    }
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const res = { ...parsed };
    if (res.status === 'userExists') {
      alertCtk(
        '<b>Tento uživatel už existuje!</b><br>Přihlaste se vpravo nahoře a prodlužte produkt na profilové stránce.<br>Pokud jste heslo zapomněli, <a href="pass.php?cmd=req">obnovte si ho zde</a>',
      );
      return false;
    }
    if (res.status === 'unknownError') {
      alertCtkApiError();
      return false;
    }
    if (res.error === 'APINotOK') {
      alertCtk(
        'Stránky jsou momentálně nedostupné, zkuste provést akci později nebo nás kontaktujte na e-mailu shop@ctk.cz',
      );
      return false;
    }

    const crc = parsed.crc;
    delete res.crc;
    const redirect = cnfg_http_mojectk_php_base + 'final.php'; // http://localhost/ctk24/final.php
    const url1 =
      'https://shop.ctk.cz/platba?src=CTK24&redirect=' +
      redirect +
      '&data=' +
      encodeURI(JSON.stringify(res)) +
      '&cr=' +
      parsed.crc;
    console.log('url: ' + url1);
    ajaxPlatebniBranaPost(res, crc);
  };

  ajaxUniPostUsingCaptcha('MakeGuestOrder', data, successFunc, 'guestorder');
}
